import React, {Fragment} from 'react'
import {connect} from 'react-redux'
import Fab from '@material-ui/core/Fab';
import Spinner from '../components/Spinner'
import { fieldErrors } from '../utils/errors'
import HeaderPlain from '../components/HeaderPlain'
import { graphql, StaticQuery, navigate, Link } from 'gatsby'
import {checkPhoneNumber, checkEmail, forgotEmailPassword, forgotPhonePassword} from '../utils/Helper'
import GreenArrow from '../assets/arrow-green.svg'
import { pushToDataLayer, logPage, logEvent } from '../components/Analytics'

class ForgotPassword extends React.Component{
    constructor(props){
        super(props)

        if(this.props.isUserLogin){
			navigate('/mina-sidor');
        }

        this.state = {
            loading: false,
            disabled: false,
            username: '',
            error: '',
            success: ''
        }
    }

    componentDidMount(){
        logPage()
	}

    handleChange = (e) => {
        this.setState({[e.target.name] : e.target.value});
    }

    setError = (error) => {
        this.setState({error: error})
    }

    loadingPage = (status) => {
        this.setState({loading: status, disabled: status});
    }

    forgotPassword = () => {
        const { username } = this.state;

        if(username === ''){
            this.setError(fieldErrors.loginDetailEmpty)
            return false
        }

        this.loadingPage(true);
        this.setError('')

        if(checkEmail(username)){
            forgotEmailPassword(username, (data) => {
                console.log('call', data)
                if(data.status){
                    this.setState({success: data.msg})
                }
                else{
                    this.setError(data.error)
                }
                this.loadingPage(false);
            });
        }
        else if(checkPhoneNumber(username)){
            forgotPhonePassword(username, (data) => {
                console.log('call', data)
                if(data.status){
                    this.setState({success: data.msg})
                }
                else{
                    this.setError(data.error)
                }
                this.loadingPage(false);
            });
        }
        else{
            this.setState({error: 'Vi kunde inte hitta en användare med de uppgifterna du uppgav.'})
        }

    }

    render(){
        const {eyes} = this.props.query;
        const { loading, disabled, username, error, success } = this.state;

        return(
            <Fragment>
                <HeaderPlain logoColor="#46e2b9" headerClass="login-header" title="Albert"/>
                <section className="login-middle">
                    <div className="custom-container">
                        <div className="login-form">
                            <h3>Glömt lösenord?</h3>
                            <h6>Skriv in ditt telefonnummer eller e-mailadress nedan så <br/> skickar vi instruktioner om hur du återställer ditt <br/>  lösenord!</h6>
                            <div className="form-group">
                                <label>Telefonnummer eller E-postadress</label>
                                <input type="text" placeholder="dittnamn@epost.se" name="username" value={username} onChange={e => this.handleChange(e)}/>
                            </div>
                            

                            <Fab
                                variant="extended"
                                color="primary"
                                aria-label="Add"
                                className="registerButton login-btn"
                                disabled={disabled}
                                onClick={(e) => {
                                        this.forgotPassword(e);
                                        logEvent(
                                            `Forgot password page Skicka lösenord button`,
                                            `Forgot password page Skicka lösenord button was clicked`
                                        )
                                        pushToDataLayer(
                                            'userClick',
                                            'Forgot Password Page Skicka Lösenord Button',
                                            'Forgot Password Page Skicka Lösenord Button Was Clicked'
                                        )
                                    }
                                }
                                >
                                Skicka lösenord
                            </Fab>
                            {
                                loading && (
                                    <Spinner size={48}/>
                                )
                            }
                            <p style={{color: 'red', margin: '2rem 0 0 0'}}>{error}</p>
                            <p style={{color: '#3d9882', margin: '2rem 0 0 0'}}>{success}</p>
                        </div>
                        <div className='tillbaka'><Link to="/login"><GreenArrow /> Tillbaka till Logga in</Link></div>
                    </div>
                </section>
            </Fragment>
        )
    }
}

const reducerProp = (state) => {
	return {
		isUserLogin: state.isUserLogin
	}
}
const ConnectRedux = connect(reducerProp)(ForgotPassword)

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    eyes: file(relativePath: {regex: "/eyes/"}) {
                        publicURL
                    }                    
                }`
            }
        render={(data)  => (
           <ConnectRedux query={data} {...props}/>
        )}
    />
)